import type { GatsbyBrowser } from 'gatsby';
import * as React from 'react';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { BlogStateProvider } from './src/contexts/BlogStateContext';
import { FontProvider } from './src/contexts/FontContext';
import { LanguageProvider } from './src/contexts/LanguageContext';
import './src/styles/global.css';
import 'prism-themes/themes/prism-vsc-dark-plus.css';
/**
 * Gatsby Browser API: wrapRootElement
 * 모든 페이지에 컨텍스트 프로바이더를 래핑합니다.
 */
export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => {
  return (
    <FontProvider>
      <LanguageProvider>
        <BlogStateProvider>
          {element}
          <Analytics />
          <SpeedInsights />
        </BlogStateProvider>
      </LanguageProvider>
    </FontProvider>
  );
};

/**
 * Gatsby Browser API: onClientEntry
 * PWA 설치 프롬프트를 방지합니다.
 */
export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
  // PWA 설치 프롬프트 자동으로 뜨지 않도록 방지
  if (typeof window !== 'undefined') {
    window.addEventListener('beforeinstallprompt', (e) => {
      // 설치 프롬프트가 자동으로 표시되지 않도록 방지
      e.preventDefault();
    });
  }
};
